// Reconstructed from production code; original paths and local names were not available.
import { Link } from "react-router-dom";
import { MEDIA_BASE_URL } from "../services/config.js";
import { NavLink } from "react-router-dom";
import React from "react";
import * as jsxRuntime from "react/jsx-runtime";
import { useAuth } from "../context/AuthContext.jsx";
import { useCart } from "../context/CartContext.jsx";
import { useFilters } from "../context/FiltersContext.jsx";
import { useLanguage } from "../context/LanguageContext.jsx";
import { useNavigate } from "react-router-dom";
import { useTheme } from "../context/ThemeContext.jsx";
function SearchIcon({ className: className }) {
  return (
    <svg
      className={className}
      viewBox={"0 0 24 24"}
      fill={"none"}
      stroke={"currentColor"}
      strokeWidth={"1.6"}
      strokeLinecap={"round"}
      strokeLinejoin={"round"}
      aria-hidden={"true"}
    >
      <circle cx={"9"} cy={"20"} r={"1.6"} />
      <circle cx={"18"} cy={"20"} r={"1.6"} />
      <path
        d={
          "M2.5 4h2.4l2.1 10.2a2 2 0 0 0 2 1.6h8.6a2 2 0 0 0 2-1.6l1.2-6.2H6.6"
        }
      />
    </svg>
  );
}
function CartIcon({ className: className }) {
  return (
    <svg
      className={className}
      viewBox={"0 0 24 24"}
      fill={"none"}
      stroke={"currentColor"}
      strokeWidth={"1.8"}
      strokeLinecap={"round"}
      strokeLinejoin={"round"}
      aria-hidden={"true"}
    >
      <path d={"M6 6l12 12M18 6l-12 12"} />
    </svg>
  );
}
function MenuIcon({ className: className }) {
  return (
    <svg
      className={className}
      viewBox={"0 0 24 24"}
      fill={"none"}
      stroke={"currentColor"}
      strokeWidth={"1.8"}
      strokeLinecap={"round"}
      aria-hidden={"true"}
    >
      <path d={"M4 7h16M4 12h16M4 17h16"} />
    </svg>
  );
}
function Header() {
  const { user: user, logout: logout } = useAuth(),
    { theme: theme } = useTheme(),
    { resetFilters: resetFilters } = useFilters(),
    { language: language, setLanguage: setLanguage, t: t, tProd: tProd, tText } = useLanguage(),
    {
      items: items,
      total: total,
      loading: loading,
      error: error,
      updateItemQuantity: updateItemQuantity,
      removeItem: removeItem,
    } = useCart(),
    [E, M] = React.useState(false),
    [N, T] = React.useState(false),
    Y = useNavigate(),
    $ = React.useRef(null),
    I = React.useRef(null),
    K = Array.isArray(items)
      ? items.reduce((B, F) => B + (F.quantity || 0), 0)
      : 0,
    J = () => {
      M(false);
    },
    Q = () => {
      T(false);
    },
    W = () => {
      M(false);
      T(false);
    },
    te = () => {
      T(false);
      M((B) => !B);
    };
  React.useEffect(() => {
    if (!(E || N)) return;
    const F = (re) => {
      if (re.key !== "Escape") return;
      const ge = N;
      W();
      ge && window.requestAnimationFrame(() => $.current?.focus());
    };
    document.body.classList.add("navbar-overlay-open");
    window.addEventListener("keydown", F);
    return () => {
      document.body.classList.remove("navbar-overlay-open");
      window.removeEventListener("keydown", F);
    };
  }, [E, N]);
  React.useEffect(() => {
    if (!N) return;
    const B = window.requestAnimationFrame(() => {
      I.current?.focus();
    });
    return () => window.cancelAnimationFrame(B);
  }, [N]);
  const oe = (B, F) => {
      const re = Number(F);
      Number.isNaN(re) ||
        re < 0 ||
        updateItemQuantity(B.id, re).catch(() => {});
    },
    he = () => {
      items.length && (M(false), Y("/checkout"));
    },
    be = theme.site_name || "MyShop",
    fe = language === "ar",
    pe = fe ? "فتح القائمة" : "Open menu",
    ye = fe ? "إغلاق القائمة" : "Close menu",
    R = fe ? "سلة التسوق" : "Shopping cart";
  return (
    <jsxRuntime.Fragment>
      <nav
        className={"navbar"}
        aria-label={fe ? "التنقل الرئيسي" : "Main navigation"}
      >
        <button
          type={"button"}
          className={"nav-mobile-menu-trigger"}
          ref={$}
          aria-label={pe}
          aria-controls={"mobile-site-navigation"}
          aria-expanded={N}
          onClick={() => {
            M(false);
            T((B) => !B);
          }}
        >
          <MenuIcon className={"nav-mobile-menu-icon"} />
        </button>
        <div className={"nav-left"}>
          <Link
            to={"/"}
            className={"logo" + (theme.logo ? " logo-image-link" : "")}
            aria-label={be}
            onClick={() => {
              resetFilters();
              W();
            }}
          >
            {theme.logo ? (
              <span className={"logo-with-img"}>
                <img
                  src={theme.logo}
                  alt={be}
                  loading={"eager"}
                  decoding={"async"}
                />
              </span>
            ) : (
              <span className={"logo-text"}>{be}</span>
            )}
          </Link>
        </div>
        <div className={"nav-links"}>
          <NavLink
            className={({ isActive: isActive }) =>
              `nav-link${isActive ? " is-active" : ""}`
            }
            to={"/"}
            end={true}
            onClick={W}
          >
            {t("home")}
          </NavLink>
          <NavLink
            className={({ isActive: isActive }) =>
              `nav-link${isActive ? " is-active" : ""}`
            }
            to={"/products"}
            onClick={W}
          >
            {t("shop")}
          </NavLink>
          <NavLink
            className={({ isActive: isActive }) =>
              `nav-link${isActive ? " is-active" : ""}`
            }
            to={"/partners"}
            onClick={W}
          >
            {t("partners")}
          </NavLink>
        </div>
        <div className={"nav-actions"}>
          <button
            type={"button"}
            className={"nav-lang-btn"}
            onClick={() => setLanguage(language === "ar" ? "en" : "ar")}
            aria-label={fe ? "تغيير اللغة" : "Change language"}
          >
            {language === "ar" ? "English" : "العربية"}
          </button>
          <button
            type={"button"}
            className={"nav-cart-link"}
            aria-label={K ? `${R}, ${K}` : R}
            aria-pressed={E}
            onClick={te}
          >
            <SearchIcon className={"nav-cart-icon"} />
            {K > 0 && <span className={"nav-cart-count"}>{K}</span>}
          </button>
          {["ADMIN", "CAISSE"].includes(user?.role) && (
            <Link
              className={"nav-link nav-link-admin"}
              to={user?.role === "CAISSE" ? "/admin/caisse" : "/admin/products"}
              onClick={W}
            >
              {t("admin")}
            </Link>
          )}
          {user ? (
            <button className={"btn btn-ghost nav-logout"} onClick={logout}>
              {t("logout")}
            </button>
          ) : null}
        </div>
      </nav>
      {N && (
        <jsxRuntime.Fragment>
          <button
            type={"button"}
            className={"mobile-nav-backdrop"}
            aria-label={ye}
            onClick={() => {
              Q();
              $.current?.focus();
            }}
          />
          <section
            id={"mobile-site-navigation"}
            className={"mobile-nav-sheet"}
            role={"dialog"}
            aria-modal={"true"}
            aria-label={fe ? "التنقل في المتجر" : "Store navigation"}
          >
            <header className={"mobile-nav-sheet-header"}>
              <span className={"mobile-nav-site-name"}>{be}</span>
              <button
                type={"button"}
                className={"mobile-nav-close"}
                ref={I}
                onClick={() => {
                  Q();
                  $.current?.focus();
                }}
                aria-label={ye}
              >
                <CartIcon className={"icon-18"} />
              </button>
            </header>
            <nav
              className={"mobile-nav-links"}
              aria-label={fe ? "التنقل الرئيسي" : "Primary navigation"}
            >
              <Link className={"mobile-nav-link"} to={"/"} onClick={W}>
                {t("home")}
              </Link>
              <Link className={"mobile-nav-link"} to={"/products"} onClick={W}>
                {t("shop")}
              </Link>
              <Link className={"mobile-nav-link"} to={"/partners"} onClick={W}>
                {t("partners")}
              </Link>
              {["ADMIN", "CAISSE"].includes(user?.role) && (
                <Link
                  className={"mobile-nav-link mobile-nav-link-accent"}
                  to={
                    user?.role === "CAISSE"
                      ? "/admin/caisse"
                      : "/admin/products"
                  }
                  onClick={W}
                >
                  {t("admin")}
                </Link>
              )}
            </nav>
            <div className={"mobile-nav-utility"}>
              <button
                type={"button"}
                className={"mobile-nav-language"}
                onClick={() => setLanguage(language === "ar" ? "en" : "ar")}
                aria-label={fe ? "التبديل إلى الإنجليزية" : "Switch to Arabic"}
              >
                {language === "ar" ? "English" : "العربية"}
              </button>
              {user && (
                <button
                  type={"button"}
                  className={"mobile-nav-logout"}
                  onClick={() => {
                    Q();
                    logout();
                  }}
                >
                  {t("logout")}
                </button>
              )}
            </div>
          </section>
        </jsxRuntime.Fragment>
      )}
      {E && (
        <jsxRuntime.Fragment>
          <div className={"cart-drawer-backdrop"} onClick={J} />
          <aside
            className={"cart-drawer"}
            role={"dialog"}
            aria-modal={"true"}
            aria-label={t("cartTitle")}
          >
            <header className={"cart-drawer-header"}>
              <div>
                <h2>{t("cartTitle")}</h2>
                <p className={"cart-muted cart-drawer-subtitle"}>
                  {K > 0 ? `${K} ${t("cartCount")}` : t("cartEmpty")}
                </p>
              </div>
              <button
                type={"button"}
                className={"cart-drawer-close"}
                onClick={J}
                aria-label={tText("Close cart")}
              >
                <CartIcon className={"icon-18"} />
              </button>
            </header>
            {error && (
              <div className={"cart-alert-error cart-drawer-error"}>
                {tText(error)}
              </div>
            )}
            <section className={"cart-drawer-body"}>
              {loading && <p className={"cart-muted"}>{t("updatingCart")}</p>}
              {!loading && items.length === 0 && (
                <p className={"cart-muted cart-drawer-empty"}>
                  {t("cartEmpty")}
                  {" 🛒"}
                  <br />
                  <span
                    style={{
                      fontSize: "0.82rem",
                      marginTop: "0.5rem",
                      display: "block",
                    }}
                  >
                    {t("cartBrowse")}
                  </span>
                </p>
              )}
              {items.map((B) => {
                const F = B.variant_image_url || B.product_image_url,
                  re = F
                    ? F.startsWith("http")
                      ? F
                      : `${MEDIA_BASE_URL}${F}`
                    : null,
                  ge = B.line_total || B.unit_price * B.quantity;
                return (
                  <div className={"cart-item cart-item-drawer"} key={B.id}>
                    {re && (
                      <img
                        src={re}
                        alt={tProd(B.product_name)}
                        className={"cart-item-img cart-item-img-small"}
                      />
                    )}
                    <div className={"cart-item-info"}>
                      <h3 className={"cart-item-title"}>
                        {tProd(B.product_name)}
                      </h3>
                      {B.variant_name && (
                        <div className={"cart-item-variant"}>
                          {t("size")}
                          {": "}
                          <span>{tProd(B.variant_name)}</span>
                        </div>
                      )}
                      {B.short_description && (
                        <p className={"cart-item-desc"}>
                          {tProd(B.short_description, B, "short_description")}
                        </p>
                      )}
                      <div className={"cart-item-footer"}>
                        <div className={"cart-qty-control"}>
                          <button
                            type={"button"}
                            onClick={() => oe(B, B.quantity - 1)}
                          >
                            {"-"}
                          </button>
                          <input
                            type={"number"}
                            min={0}
                            value={B.quantity}
                            onChange={(j) => oe(B, Number(j.target.value) || 0)}
                          />
                          <button
                            type={"button"}
                            onClick={() => oe(B, B.quantity + 1)}
                          >
                            {"+"}
                          </button>
                        </div>
                        <div className={"cart-item-prices"}>
                          <span className={"cart-unit-price"}>
                            {B.unit_price.toFixed(3)}
                          </span>
                          <span className={"cart-line-total"}>
                            {ge.toFixed(3)}
                          </span>
                        </div>
                      </div>
                      <button
                        type={"button"}
                        className={"cart-remove-btn"}
                        onClick={() => removeItem(B.id).catch(() => {})}
                      >
                        {t("remove")}
                      </button>
                    </div>
                  </div>
                );
              })}
            </section>
            <footer className={"cart-drawer-footer"}>
              <div className={"cart-summary-row cart-summary-row-strong"}>
                <span>{t("total")}</span>
                <span>
                  {total.toFixed(3)} {t("priceOMR")}
                </span>
              </div>
              <button
                className={"cart-checkout-btn"}
                disabled={items.length === 0}
                onClick={he}
              >
                {t("checkout")}
              </button>
            </footer>
          </aside>
        </jsxRuntime.Fragment>
      )}
    </jsxRuntime.Fragment>
  );
}
export { SearchIcon, CartIcon, MenuIcon, Header };
